<template>
  <div>
    <b-card no-header>
      <form>
        <app-remito-estado
          label="Estado"
          :nombre="remitoEstadoNombre"
          :lista="remitosEstadosList"
          :label-cols="labelCols"
          labelOption="Seleccione un estado"
          @updated="remitoEstadoActualizado">
        </app-remito-estado>  
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import RemitoEstado from '../shared/abmSelect.vue';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'


export default {
  name: 'RemitosActualizacionEstado',
  props: {
    remitoId: {
      type: Number,
      default: 0,
    },
    remitos: {
      type: Array,
      default: null,
    },
    remitoEstadoActual: {
      type: String,
      default: null
    } 
  },
  components: {
    appRemitoEstado: RemitoEstado,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      remitoEstado: null,
      remitoEstadoNombre: null,
      remitosEstados: [],
      remitosEstadosList: [],
      labelCols: 2,
    }
  },
  created() {
    this.remitoEstadoNombre = this.remitoEstadoActual;
    this.getDatosAdicionales();
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('remitosEstados/getList')
        .then(() => {
          this.remitosEstados = this.$store.getters['remitosEstados/list'];
          this.remitosEstadosList = this.$store.getters['remitosEstados/selectList'];
        })
    },    
    save () {
      let save = true;

      if (this.remitoId == 0) {
        let errorRemitos = true;
        if (this.remitos) {
          errorRemitos = this.remitos.length == 0;
        }
        if (errorRemitos) {
          this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de remitos a actualizar'))
          save = false;
        }
      }

      if (!this.remitoEstado) {
        this.showErrorMsj(new Error('Seleccione el nuevo estado para completar la actualización'))
        save = false;
      }
      
      if (save) {
        this.showSpinner();
        let params = {
          remitoId: this.remitoId,
          remitos: this.remitos,
          remitoEstadoId: this.remitoEstado.id
        }
        let msj = 'La información del remito se actualizó con éxito';
        if (this.remitoId == 0) {
          msj = 'La información de los remitos seleccionados se actualizó con éxito';
        }
        this.$store.dispatch('remito/actualizarEstado', params)
          .then(() => this.showModalMsj(msj, this.close, this.close, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    close() {
      this.$emit('close', true)
    },
    cancelar() {
      this.$emit('close', false)
    },
    remitoEstadoActualizado(remitoEstadoNombre) {
      this.remitoEstado= null;
      if (remitoEstadoNombre) {
        this.remitoEstado = this.getSelected(this.remitosEstados, remitoEstadoNombre);
      }
    },
  },
  watch: {
  }    
}
</script>

<style>
</style>
